import { CurrentView, FloorViewMode, ProjectFocusMode } from './-constants'
import { BuildingState } from './-types'

export default (): BuildingState => ({
  currentView: CurrentView.BUILDING,
  canvasElement: null,
  cdnBase: '',
  buildingCode: '',
  project: {},
  activeProject: '',
  client: '',
  space: {},
  isInitialized: false,
  floorViewMode: FloorViewMode.DEFAULT,
  projectFocusMode: ProjectFocusMode.DEFAULT,
  fitoutData: {
    initialized: false,
    data: []
  },
  loadingScreenActive: true,
  finishedLoadingAssets: false,
  settings: {},
  assetLoadingError: null,
  isFullFloorSelected: false,
  defaultFilterPinsMode: '',
  webGLContextLost: false,
  activeFocusPointPin: null
})
